import React from 'react';
import './table.css';
import Table from 'react-bootstrap/Table';
import Form from 'react-bootstrap/Form';
import Button from "react-bootstrap/Button";
import ReactPaginate from 'react-paginate';
import { Link } from 'react-router-dom';
import { AuthContext } from "../login/Auth";

class UserTable extends React.Component {
    static contextType = AuthContext;

    constructor(props) {
        super(props);
        this.state = {
            patient_data: null,
            search: "",
            currentPage: 0,
            patientsPerPage: 50, // Default records per page
        };
        this.renderPatient = this.renderPatient.bind(this);
    }

    async componentDidMount() {
        this.setState({ patient_data: this.props.data });
    }

    handleSearch = (event) => {
        const { value } = event.target;
        this.setState({ search: value, currentPage: 0 });
    };

    handlePageClick = (data) => {
        this.setState({ currentPage: data.selected });
    };

    handleRecordsPerPageChange = (event) => {
        const value = event.target.value;
        this.setState({
            patientsPerPage: value === "all" ? this.state.patient_data.length : parseInt(value, 10),
            currentPage: 0, // Reset to the first page
        });
    };

    renderPatient(patient, index) {
        let { allowEdit } = this.context;
        return (
            <tr key={index}>
                <td>{patient.patient_id}</td>
                <td>{patient.gender}</td>
                <td>{patient.year_of_birth}</td>
                <td>{patient.examination_age}</td>
                <td>{patient.initial_diagnosis}</td>
                <td className="user-table-actions">
                <Link
                    to={{
                        pathname: `/editPatient/${patient.patient_id}`,
                        state: { id: patient.patient_id, age: patient.examination_age },
                    }}
                >
                    {allowEdit ? (
                        <Button variant="outline-info">Edit Patient</Button>
                    ) : (
                        <Button variant="outline-info">View Patient</Button>
                    )}
                </Link>
            </td>
            </tr>
        );
    }

    render() {
        const { patient_data, search, currentPage, patientsPerPage } = this.state;

        if (patient_data == null) {
            return <h1>Loading</h1>;
        } else {
            // Filter data based on search input
            const filteredData = patient_data.filter((patient) =>
                patient.patient_id.toLowerCase().includes(search.toLowerCase())
            );

            // Paginate data
            const offset = currentPage * patientsPerPage;
            const currentPageData = filteredData.slice(offset, offset + patientsPerPage);
            const pageCount = Math.ceil(filteredData.length / patientsPerPage);

            return (
                <div className="App">
                    <Form className="user-table-container">
    <div className="user-table-controls">
        {/* Search Bar */}
        <Form.Label className="user-table-label">Search</Form.Label>
        <Form.Control
            className="user-table-search-bar"
            type="text"
            onChange={this.handleSearch}
            value={search}
            placeholder="Search by Patient ID"
        />

        {/* Dropdown for Records Per Page */}
        <Form.Label className="user-table-label">Patients per page</Form.Label>
        <Form.Control
            as="select"
            onChange={this.handleRecordsPerPageChange}
            defaultValue={50}
            className="user-table-records-dropdown"
        >
            <option value={20}>20</option>
            <option value={50}>50</option>
            <option value={100}>100</option>
            <option value="all">All</option>
        </Form.Control>
    </div>
</Form>
<div className="user-table-container">
    <div className="user-table-wrapper">
        <Table
            responsive
            bordered={false}
            className="user-table"
        >
            <thead>
                <tr>
                    <th>Patient ID</th>
                    <th>Gender</th>
                    <th>Year of Birth</th>
                    <th>Examination Age</th>
                    <th>Initial Diagnosis</th>
                    <th>Action</th>
                </tr>
            </thead>
            <tbody>
                {currentPageData.map(this.renderPatient)}
            </tbody>
        </Table>
    </div>
</div>

                    {/* <Table
                        responsive={true}
                        className="table"
                        bordered={false}
                        size="md"
                        hover={true}
                        striped={false}
                    >
                        <thead>
                            <tr>
                                <th width={350}>Patient ID</th>
                                <th>Gender</th>
                                <th>Year of Birth</th>
                                <th>Examination Age</th>
                                <th>Initial Diagnosis</th>
                                <th>Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {currentPageData.map(this.renderPatient)}
                        </tbody>
                    </Table> */}
                    <ReactPaginate
                        previousLabel={"Previous"}
                        nextLabel={"Next"}
                        breakLabel={"..."}
                        pageCount={pageCount}
                        marginPagesDisplayed={2}
                        pageRangeDisplayed={3}
                        onPageChange={this.handlePageClick}
                        containerClassName={"pagination"}
                        activeClassName={"active"}
                        previousClassName={"page-item"}
                        nextClassName={"page-item"}
                        pageClassName={"page-item"}
                        pageLinkClassName={"page-link"}
                        previousLinkClassName={"page-link"}
                        nextLinkClassName={"page-link"}
                        breakClassName={"page-item"}
                        breakLinkClassName={"page-link"}
                    />
                </div>
            );
        }
    }
}

export default UserTable;
